import { Text, LinkButton, Tooltip } from '$components'
import { CalendarIcon, PlusIcon } from '$components'
import { AppointmentRoutePath } from '../routes/protected'
import { useTenant } from '$features/auth/hooks/use-tenant'
import { Router } from '$utils/router'
import { SUBSCRIPTION_EXPIRED_MESSAGE } from '$constants/subscription'

export type NoAppointmentsEmptyStateProps = {
  isNoResults: boolean
}

export function NoAppointmentsEmptyState({ isNoResults = false }: NoAppointmentsEmptyStateProps) {
  const { hasSubscriptionExpired } = useTenant()

  return (
    <div className="w-full h-fit p-12 bg-neutral-50 rounded-3xl flex flex-col items-center justify-center text-center">
      <CalendarIcon className="size-12 text-indigo-500 mb-4" />

      <Text
        type="h3"
        className="mb-4 text-gray-900"
      >
        {!isNoResults ? 'No appointments scheduled yet' : 'No appointments found'}
      </Text>

      <Text
        type="s"
        className="text-gray-600 max-w-md mb-6"
      >
        {!isNoResults
          ? 'Schedule your first appointment to start managing your client bookings and pet grooming services.'
          : 'No appointments found matching your search. Try adjusting your search criteria or schedule a new appointment.'
        }
      </Text>

      {isNoResults && (
        <Tooltip
          content={hasSubscriptionExpired ? SUBSCRIPTION_EXPIRED_MESSAGE : undefined}
          disabled={!hasSubscriptionExpired}
        >
          <LinkButton
            to={Router.getRoute(AppointmentRoutePath.AppointmentsCreate)}
            icon={PlusIcon}
            disabled={hasSubscriptionExpired}
          >
            New Appointment
          </LinkButton>
        </Tooltip>
      )}
    </div>
  )
}
